import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	width: calc(100% - 80px);
	height: 40px;
	display: flex;
	gap: 30px;
	overflow-x: scroll;
	overflow-y: hidden;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledTabLine = styled.div`
	position: absolute;
	bottom: 0;
	left: var(--left);
	width: var(--width);
	height: 2px;
	background-color: white;
	transition:
		left 0.25s ease,
		width 0.25s ease;
`;

export { StyledContainer, StyledTabLine };
